export const getFormPage = ((state) => state.form.label)
export const getFormData = ((state) => state.form.value)
export const editFormData = ((state) => state.form.edit)
export const getEditFormData = ((state) => state.form.edit.value)
export const getIsPublic = (state) => state.form.isPublic
export const getFormLoading = (state) => state.form.loadingLabel || state.form.loadingValue
